import { render, staticRenderFns } from "./curationPreview.vue?vue&type=template&id=2d448d50&scoped=true&"
import script from "./curationPreview.vue?vue&type=script&lang=js&"
export * from "./curationPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d448d50",
  null
  
)

export default component.exports